import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import '../dashboard/styles/login.css';

const PrivateRoute = ({ element, ...rest }) => {
  // Utilisateur et mot de passe codés en dur
  const validUsername = 'admin';
  const validPassword = 'password123';

  // États pour gérer le formulaire de connexion
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    if (username === validUsername && password === validPassword) {
      setIsAuthenticated(true);
    } else {
      alert('Nom d’utilisateur ou mot de passe incorrect');
    }
  };

  // Si authentifié, retourner l'élément
  if (isAuthenticated) {
    return element;
  }

  // Sinon, afficher le formulaire de connexion
  return (
    <div className="login-container">
      <h2>Connexion Administrateur</h2>
      <form onSubmit={handleLogin}>
        <div>
          <label>Nom d'utilisateur</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div>
          <label>Mot de passe</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button type="submit">Se Connecter</button>
      </form>
    </div>
  );
};

export default PrivateRoute;
